import axios from "vue-app/utils/axios";
import { DTOActionRequiredNotificationType } from "./dto";

export const getDashboardNotification = async () => {
  const { data } = await axios.get<DTOActionRequiredNotificationType>("/notification/dashboard");
  return data;
};
